import React from 'react'
import { ElementProps } from '../base/element'
import { ICommonProps, IDefaultStyles } from '../schemamanager/types'

export interface IImageComponent extends ICommonProps {
    type: 'image',
    src: string,
    width?: string, 
    height?: string, 
    alt?: string,
}

const style: IDefaultStyles = {
  main: {
    classes: {
      margin: 'mx-2 my-1'
    }
  }
}


export const Image = (props: ElementProps) => {
  const comp = props.comp as IImageComponent

  const m = props.mergeStyles(style)

  return (
    <img src={comp.src} width={comp.width} height={comp.height} alt={comp.alt} {...m.main} {...props.events()}/>
  )
}
